import { render, staticRenderFns } from "./teacherTraining.vue?vue&type=template&id=7b3052b4"
import script from "./teacherTraining.vue?vue&type=script&lang=js"
export * from "./teacherTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports